var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIconBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40pt",
    height: "40pt",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      fill: "rgb(90.980392%,68.235294%,15.294118%)",
      fillOpacity: 1,
      strokeWidth: 1.2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(90.980392%,68.235294%,15.294118%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 10.55957 2.528125 C 10.907617 2.442188 11.287891 2.487305 11.620898 2.687109 C 11.816406 2.805273 11.981836 2.970703 12.1 3.166211 L 19.469141 15.44668 C 19.666797 15.777539 19.711914 16.157812 19.625977 16.505859 C 19.537891 16.853906 19.31875 17.167578 18.987891 17.367383 C 18.770898 17.498438 18.52168 17.567187 18.268164 17.567187 L 3.532031 17.567187 C 3.145313 17.567187 2.795117 17.410352 2.541602 17.156836 C 2.288086 16.90332 2.133398 16.553125 2.133398 16.166406 C 2.133398 15.912891 2.202148 15.663672 2.331055 15.44668 L 9.700195 3.166211 C 9.897852 2.835352 10.213672 2.616211 10.55957 2.528125 Z M 10.55957 2.528125 ",
    transform: "matrix(1.818182,0,0,1.818182,0,1.090909)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1.2,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 0.706523 4.764447 L 0.706523 -0.000787063 ",
    transform: "matrix(1.818182,0,0,-1.818182,18.781818,23.025913)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 21.871094 26.84375 C 21.871094 27.847656 21.058594 28.664062 20.054688 28.664062 C 19.050781 28.664062 18.238281 27.847656 18.238281 26.84375 C 18.238281 25.839844 19.050781 25.027344 20.054688 25.027344 C 21.058594 25.027344 21.871094 25.839844 21.871094 26.84375 Z M 21.871094 26.84375 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconBig);
export default __webpack_public_path__ + "static/media/warning-icon-big.6171381021ede6376cd19f5de0b2d4bb.svg";
export { ForwardRef as ReactComponent };